import {
  StateProps,
  ContainerProps,
  makeMapStateToProps,
  mapDispatchToProps,
  DispatchProps,
} from "./map-to-props-factory";
import { ComponentProps } from "./props";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";

export default withSportsbookBetslipContext(({ localization, config }: SportsbookBetslipContext) => ({
  localization,
  config,
}))(
  createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
